<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
  <div ref="wy-associate-tasks-info">
    <el-popover trigger="click" v-model="visible" popper-class="wy-associate-tasks-info-popover" placement="bottom" title="" width="340">
      <div class="wy-associate-tasks-info-header-right" >
        <div class="signal-popper-header">
          <div class="header-title">Associated tasks</div>
          <img @click="closePopover" style="cursor: pointer; z-index:9999" src="../../assets/icons/icon_customer_close.svg" />
        </div>
        <div class="signal-margin" />
        <div class="title">Task name</div>
        <div class="scrollable-section">
          <div class="scrollable-body" v-for="(item, index) in row.tasks" :key="index">
            <span @mouseover="handleMouseOver($event, item.taskName)" @mouseout="controller.mouseout" class="tasks-content">{{item.taskName}}</span>
          </div>
        </div>
      </div>
      <button slot="reference" class="topic-info" @mouseover="mouseover($event, 'Associated tasks', 'normal', '', false)" @mouseout="mouseout" @click="handleInfoClick"></button>
    </el-popover>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapMutations } from 'vuex';

export default Vue.extend({
  name: 'wy-associate-tasks-info',
  props: {
    controller: {
      type: Object,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
    };
  },

  computed: {
    ...mapGetters(['transcriptInfoReference', 'companyConfig']),

  },
  methods: {
    ...mapMutations(['updateTranscriptInfoReference']),

    isShowSubTopic(transcript) {
      const hasOriginalTopicName = transcript.originalTopicName
      const isSubTopicNameSameAsTopicName = transcript.originalTopicName === transcript.topicDisplayName

      return hasOriginalTopicName && !isSubTopicNameSameAsTopicName
    },    

    handleInfoClick(e) {
      e.preventDefault();
      e.stopPropagation();
      this.closeAllPopovers();
      this.controller.currentPopover = this;
    },
    closePopover() {
      this.visible = false;
      this.updateTranscriptInfoReference(null);
    },

    closeAllPopovers() {
      if(this.visible) {
        let popovers = document.querySelectorAll('.wy-associate-tasks-info-popover');
        if(popovers) {
          popovers.forEach((popover) => {
            popover.style.display = 'none';
          });
        }
        this.visible = false;
      }
      else {
        let popovers = document.querySelectorAll('.wy-associate-tasks-info-popover');
        if(popovers) {
          popovers.forEach((popover) => {
            popover.style.display = 'none';
          });
        }
      }
    },

    handleMouseOver(event, item) {
      if (event.target.getBoundingClientRect().width > 208) {
        return this.controller.mouseover(event, item, '', '', false)
      }
    },
    mouseover(e, tooltips, type, column, isFromHeader) {
      e.stopPropagation();
      let ignoreClassName = e.target.className != 'assigned-intent' && e.target.className != 'el-select-dropdown__item' && e.target.className != 'el-select-dropdown__item hover' 
      && e.target.className != 'ignore-wrap-div' && e.target.className != 'existing-intent-popover-item' && e.target.className != 'el-select__caret el-input__icon el-icon-arrow-up' 
      && e.target.className != 'el-select el-select--mini' && e.target.className != 'change-suffix'
      
      let isCustomizedTooltip = false;
      if(column && column.label == '% change'|| column == 'totalTopic' || column == '' || (!isFromHeader && column && column.label && column.label == 'Total')) {
        isCustomizedTooltip = true;
      }
      if(((e.target.classList.contains('wy-table-content')|| e.target.classList.contains('row-overflow-style') || e.target.classList.contains('highlight-keywords')) && !e.target.classList.contains('edit')) || isCustomizedTooltip){
        if(tooltips && tooltips.trim() != '' && ignoreClassName) {
          let tooltipsEl = document.querySelector(".site-tooltips");
          if(tooltipsEl) {
            tooltipsEl.classList.add('black-background');
            tooltipsEl.innerHTML = tooltips
            tooltipsEl.style.display = 'block';
            tooltipsEl.style.left = `${e.target.getBoundingClientRect().x + 10}px`;
            if(column && column.label == '% change') {
              tooltipsEl.style.left = `${e.target.getBoundingClientRect().x - 50}px`;
            }
            if(type == "right") {
              tooltipsEl.style.right = "10px";
              tooltipsEl.style.left = "380px";
            }
            if(type == "left") {
              tooltipsEl.style.left = "346px";
              tooltipsEl.style.right = "unset";
            }
            if (type == 'normal') {
              tooltipsEl.style.left = `${e.target.getBoundingClientRect().x - tooltipsEl.getBoundingClientRect().width / 2 + e.target.getBoundingClientRect().width / 2}px`;
            }
            tooltipsEl.style.top = `${e.target.getBoundingClientRect().top + e.target.getBoundingClientRect().height + 5}px`;
          }
        }
        else {
          e.preventDefault();
        }
      }
    },
    mouseout() {
      let tooltipsEl = document.querySelector(".site-tooltips");
      if(tooltipsEl) {
        tooltipsEl.style.display = 'none';
      }
    }
  },

  mounted() {
    window.addEventListener('resize', () => {
      this.closeAllPopovers();
    })
  },
});
</script>

<style lang="scss">
.interactions-message-transcripts-section {
  height: calc(100vh - 331px) !important;
  .interactions-div-message-transcripts-viewer-content {
    height: calc(100vh - 367px) !important;
  }
  .interactions-div-message-transcripts-viewer-header .el-infor-icon {
    // background-image: url('../../../assets/icons/icon_transcript_search_info.svg') !important;
    background-position-y: -1px !important;
    top: 0px !important;
    left: 1px !important;
  }
  .interactions-div-message-transcripts-viewer-header .saved-transcript-grey-star {
    background-position-y: -1px; 
  }
  .interactions-div-message-transcripts-viewer-header .saved-transcript-golden-star {
    background-position-y: -1px; 
  }

  &::-webkit-scrollbar {
    width: 20px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 160px;
    border: 2px solid transparent;
    border-top: 4px solid transparent;
    background-clip: content-box;
    background-color: #CAD2DA;
  }
  &::-webkit-scrollbar-track {
    background:#F3F6F8;
    border-top: 1px solid #CAD2DA;
  }
  &::-webkit-scrollbar:vertical {
    width: 14px;
  }
  &::-webkit-scrollbar-thumb:vertical {
    border-radius: 160px;
    border: 2px solid transparent;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    background-clip: content-box;
    background-color: #CAD2DA;
  }
  &::-webkit-scrollbar-track:vertical {
    // border-left: 1px solid #CAD2DA;
    border-top: none !important;
    border-bottom-right-radius: 20px;
  }
}

.wy-analytics-transcript-search-expand {
    .el-tooltip.info-item {
      position: relative;
      line-height: 0;
      top: -10px;
      .el-infor-icon, .el-infor-icon-metricAnalysis {
        top: 17px !important;
      }
      .summary-icon-hidden.el-infor-icon {
        left: 12px !important;
      }
    }
  }
  .el-tooltip.info-item {
    position: relative;
    line-height: 0;
    // top: -10px;
  }
.wy-associate-tasks-info-popover {
  // padding: 20px;
  margin-top: 0px!important;
  margin-bottom: 0px !important;
  max-height: 349px;
  padding: 15px 10px 15px 10px !important;
  width: 244px !important;
}

.wy-associate-tasks-info-header-right {
  color: var(--site-font-chart-color);
  font-size: 14.22px;
  font-style: normal;
  font-weight: 400;
  font-family: Helvetica Neue, Helvetica, Arial, sans-serif !important;

  .signal-popper-header {
    display: flex;
    align-content: center;
    justify-content: space-between;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    margin-top: 0px;
    padding-bottom: 15px;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif !important;

    .header-title {
      // height: 17px;
      // width: 17px;
      background: url('../../assets/icons/icon_info.svg') no-repeat;
      background-size: 20px;
      padding-left: 25px;
      position: relative;
      font-size: 14.22px;
    }
  }
  .title {
    font-size: 14.22px;
    font-style: normal;
    font-weight: 500;
    margin-top: 10px;
    padding: 10px;
    background-color: #F3F3F3;
  }
  .scrollable-section {
    overflow: auto;
    overflow-x: hidden;
    max-height: 200px;
  }
  .scrollable-body {
    margin-top: 10px;
    margin-bottom: 0px;
    padding: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 12px;

    &::-webkit-scrollbar {
      width: 16px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 160px;
      border: 4px solid transparent;

      background-clip: content-box;
      background-color: #cad2da;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
      border: 1px solid #cad2da;
      border-top: none;
      border-bottom: none;
    }
  }

  .signal-popper-info {
    display: flex;
    flex-direction: column;
    gap: 8px;
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif !important;
    padding-left: 30px;
    padding-top: 16px;
    word-break: break-word;

    .title {
      font-size: 14.22px;
      font-style: normal;
      font-weight: 700;
    }
    .fw-500 {
      font-weight: bold;

    }
  }
  .agent-info {
    margin-bottom: -10px;
  }
  .signal-margin {
    margin: 0px 0px;
    border-bottom: 1px dashed #cad2da;
  }
}

.wy-analytics-contact-reasons-detail-topic-relations, .wy-analytics-contact-reasons-detail-topic-group, .wy-analytics-contact-reasons-detail-topic-messages {
  .interactions-message-transcripts-section .interactions-div-message-transcripts-viewer-header {
    .el-tooltip.save-item {
      line-height: 0;
      position: relative;
      left: 17px;
      // top: 7px;
    }
    .el-infor-icon {
      left: 2px !important;
      top: 2px !important;
    }
    .summary-icon {
      left: 10px !important;
      // left: 5px !important;
      top: 3px !important;
    }
    .saved-transcript-grey-star, .saved-transcript-golden-star, .summary-icon,  .el-infor-icon {
      background-size: 100%;
      background-repeat: no-repeat;
      background-position-y: 0px;
      background-position-x: 0px;
      height: 20px;
      width: 20px;
      border: 0px;
      margin: 0px !important;
      padding: 0px !important;
      // left: 2px !important;
      // top: -4px !important;
      position: relative;
      border-radius: 0px;
    }
    .saved-transcript-grey-star, .saved-transcript-golden-star{
      left: 17px !important;
      top: 3px !important;
    }
  }
}

.wy-analytics-contact-reasons-detail-topic-messages {
  .interactions-message-transcripts-section .interactions-div-message-transcripts-viewer-header {
    .div-saved-transcript .el-tooltip {
      position: relative;
      left: 10px !important;
      line-height: 0;
      .el-button.saved-transcript-grey-star,.el-button.saved-transcript-golden-star {
        // left: 0px !important;
        left: 7px !important;
      }
      
    }
    .el-tooltip.summary-icon-hidden {
      .el-button.saved-transcript-grey-star,.el-button.saved-transcript-golden-star {
        left: 0px !important;
      }
    }
  }
}
.wy-analytics-contact-reasons-detail-topic-relations {
  .interactions-message-transcripts-section .interactions-div-message-transcripts-viewer-header .el-tooltip.save-item {
    line-height: 0;
    left: 17px !important;
    .el-button.saved-transcript-grey-star,.el-button.saved-transcript-golden-star {
      left: 0px !important;
    }
  }
}

.wy-analytics-contact-reasons-detail-topic-group {
  .interactions-message-transcripts-section .interactions-div-message-transcripts-viewer-header .el-tooltip.save-item {
    line-height: 0;
    left: 17px !important;
    .el-button.saved-transcript-grey-star,.el-button.saved-transcript-golden-star {
      left: 0px !important;
    }
  }
  .interactions-message-transcripts-section .interactions-div-message-transcripts-viewer-header .el-tooltip.save-item.summary-icon-hidden {
    left: 10px !important;
  }
}
.wy-analytics-transcript-search-details .div-transcript-header {
  .el-infor-icon-metricAnalysis {
    cursor: pointer;
    // background-image: url('../../../assets/icons/icon_transcript_search_info_new.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    height: 20px;
    width: 20px;
    border: 0px;
    margin: 0px !important;
    padding: 0px !important;
    left: 8px;
    top: 1px;
    position: relative;
    border-radius: 0px;
  }
  .el-infor-icon {
    cursor: pointer;
    //background-image: url('../../assets/icons/icon_transcript_search_info.svg');
    // background-image: url('../../../assets/icons/icon_transcript_search_info_new.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    height: 20px;
    width: 20px;
    border: 0px;
    margin: 0px !important;
    padding: 0px !important;
    left: -5px;
    top: 1px;
    position: absolute;
    border-radius: 0px;
  }
}

.wy-analytics-contact-reasons-detail {
  .el-infor-icon-metricAnalysis {
    cursor: pointer;
    // background-image: url('../../../assets/icons/icon_transcript_search_info_new.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    height: 20px;
    width: 20px;
    border: 0px;
    margin: 0px !important;
    padding: 0px !important;
    left: 8px;
    top: 1px;
    position: relative;
    position: relative;
    border-radius: 0px;
  }

  .summary-icon-hidden.el-infor-icon-metricAnalysis {
    left: 12px;
  }

  .el-infor-icon {
    cursor: pointer;
    // background-image: url('../../../assets/icons/icon_transcript_search_info_new.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    height: 20px;
    width: 20px;
    border: 0px;
    margin: 0px !important;
    padding: 0px !important;
    left: 8px;
    top: 1px;
    position: relative;
    border-radius: 0px;
  }
}

.wy-analytics-transcript-search-expand .div-transcript-header {
  .el-infor-icon {
    cursor: pointer;
    // background-image: url('../../../assets/icons/icon_transcript_search_info_new.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    height: 20px;
    width: 20px;
    border: 0px;
    margin: 0px !important;
    padding: 0px !important;
    left: 8px;
    top: 1px;
    position: relative;
    border-radius: 0px;
  }
}

.interactions-message-transcripts-section .interactions-div-message-transcripts-viewer-header {
  .el-infor-icon-metricAnalysis {
    cursor: pointer;
    // background-image: url('../../../assets/icons/icon_transcript_search_info_new.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    height: 20px;
    width: 20px;
    border: 0px;
    margin: 0px !important;
    padding: 0px !important;
    left: 8px;
    top: 1px;
    position: relative;
    border-radius: 0px;
  }

  .el-infor-icon {
    cursor: pointer;
    // background-image: url('../../../assets/icons/icon_transcript_search_info_new.svg');
    background-size: 100%;
    background-repeat: no-repeat;
    background-position-y: 0px;
    background-position-x: 0px;
    height: 20px;
    width: 20px;
    border: 0px;
    // margin: 0px !important;
    margin-top: 6px;
    padding: 0px !important;
    left: 8px;
    top: 1px;
    position: relative;
    border-radius: 0px;
  }
}
</style>
